import { configureStore } from "@reduxjs/toolkit";
import loaderReducer from "./Slices/loaderSlice";
import toastReducer from "./Slices/toastSlice";
import driverReducer from "./Slices/driverSlice";
import contactFormReducer from "./Slices/contactFormSlice";
import {thunk} from "redux-thunk";

const store = configureStore({
    reducer: {
        loader: loaderReducer,
        toast: toastReducer,
        driver: driverReducer,
        contactForm: contactFormReducer
    },
    middleware: ()=> [thunk],
});

export default store;
